import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios, { AxiosResponse } from 'axios';
import { User } from 'src/models/user.model';
import { searchUserById } from './user.reducer';

type InitialState = {
  emailLoading: boolean;
  emailFailure: boolean;
  emailSuccess: boolean;
  activeLoading: boolean;
  activeFailure: boolean;
  activeSuccess: boolean;
  user: User;
};

const INITIAL_STATE: InitialState = {
  emailLoading: false,
  emailFailure: false,
  emailSuccess: false,
  activeLoading: false,
  activeFailure: false,
  activeSuccess: false,
  user: null as unknown as User,
};

export const updateUser = createAsyncThunk('user/update', async (data: { user: User }, { rejectWithValue, dispatch }) => {
  try {
    const response: AxiosResponse<User> = await axios.put(`/api/user`, data);

    dispatch(searchUserById({ id: data.user.id }));

    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const updateUserActive = createAsyncThunk(
  'user-active/update',
  async (data: { id: number; active: boolean }, { rejectWithValue }) => {
    try {
      const response: AxiosResponse<User> = await axios.put(`/api/user-active`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateUserSlice = createSlice({
  name: 'update/user',
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(updateUser.pending, (state: InitialState) => {
      return {
        ...state,
        emailLoading: true,
        emailFailure: false,
        emailSuccess: false,
      };
    });
    builder.addCase(updateUser.fulfilled, (state: InitialState, action: PayloadAction<User>) => {
      return {
        ...state,
        emailLoading: false,
        emailFailure: false,
        emailSuccess: true,
        user: action.payload,
      };
    });
    builder.addCase(updateUser.rejected, (state: InitialState) => {
      return {
        ...state,
        emailLoading: false,
        emailFailure: true,
        emailSuccess: false,
      };
    });
    builder.addCase(updateUserActive.pending, (state: InitialState) => {
      return {
        ...state,
        activeLoading: true,
        activeFailure: false,
        activeSuccess: false,
      };
    });
    builder.addCase(updateUserActive.fulfilled, (state: InitialState, action: PayloadAction<User>) => {
      return {
        ...state,
        activeLoading: false,
        activeFailure: false,
        activeSuccess: true,
        user: action.payload,
      };
    });
    builder.addCase(updateUserActive.rejected, (state: InitialState) => {
      return {
        ...state,
        activeLoading: false,
        activeFailure: true,
        activeSuccess: false,
      };
    });
  },
});

export default updateUserSlice.reducer;
